import * as registerUserData from "./RegisterRedux";
import { UserRoles } from "../../../models/User";
import {FirestoreTimestamp} from "src/types/firestoreTypes"

interface InitialState {
  userId: string;
  submittedAt: FirestoreTimestamp | undefined; 
  members: Member[] | [];
  responseMessage: string;
}

export interface Member {
  id: number;
  email?: string;
  role?: UserRoles;
}

const AddMemberAction: string = "AddMember";

export default InitialState;
export { AddMemberAction };
